import CalendarSurfaceAddinsOptionState from '../store/schema/CalendarSurfaceAddinsOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-options';
import { CalendarSurfaceAddinsOptions } from 'owa-outlook-service-options';
import { select } from 'satcheljs/lib/legacy';

export interface IsSurfaceAddinsOptionDirtyState {
    optionState: CalendarSurfaceAddinsOptionState;
    userOptions: CalendarSurfaceAddinsOptions;
}

export default select<IsSurfaceAddinsOptionDirtyState>({
    optionState: () => store,
    userOptions: () =>
        getOptionsForFeature<CalendarSurfaceAddinsOptions>(
            OwsOptionsFeatureType.CalendarSurfaceAddins
        ),
})(function isSurfaceAddinsOptionDirty(state?: IsSurfaceAddinsOptionDirtyState) {
    let { optionState, userOptions } = state;

    return isOptionDirty(
        getFallbackValueIfNull(
            optionState.calendarSurfaceAddins,
            userOptions.calendarSurfaceAddins
        ),
        userOptions.calendarSurfaceAddins
    );
});

function isOptionDirty(optionState: string[], userOption: string[]): boolean {
    // For easy array comparison:
    // First, slice each array to create a copy so we don't modify the real data.
    // Second, sort them since order isn't important for this feature.
    // Third, join them to create a single string of all the actions/addins.
    // Finally, compare the strings.
    return (
        optionState
            .slice()
            .sort()
            .join() !==
        userOption
            .slice()
            .sort()
            .join()
    );
}
